module.exports = __webpack_public_path__ + "img/Logotipo_CE_Branca.cf8ae9ea.svg";